"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShiftWarnings = void 0;
const react_1 = __importDefault(require("react"));
const ui_1 = require("@app/component/ui");
const form_grid_layout_1 = require("@app/component/ui/forms/form-grid-layout");
const store_1 = require("@app/store");
const util_1 = require("@app/util");
const maybe_1 = require("@app/util/functional/maybe");
const use_plugin_1 = require("@app/util/hooks/use-plugin");
const useWorkspace_1 = require("@app/util/hooks/useWorkspace");
const moment_1 = __importDefault(require("moment"));
const react_hook_form_1 = require("react-hook-form");
const shift_context_1 = require("../shift-context");
function isDstChangeInPeriod(start, end, TZ) {
    const from = moment_1.default.tz(start, TZ).startOf('day');
    const to = moment_1.default.tz(end, TZ).endOf('day');
    return from.utcOffset() !== to.utcOffset();
}
const filterHidesWarnings = (t) => 'hideWarnings' in t;
const isSpecificFilter = (t) => Array.isArray(t.hideWarnings);
const hideWarning = (filters, warning) => filters.some((f) => f === warning.name);
const ShiftWarnings = () => {
    const { selectedTab, dummyShift, transferRole, formControl } = (0, shift_context_1.useShift)();
    const workspace = (0, useWorkspace_1.useWorkspace)();
    const timezone = workspace?.timezone;
    const { isPluginEnabled } = (0, use_plugin_1.usePlugin)();
    const periodStart = (0, react_hook_form_1.useController)({ control: formControl, name: 'period.start' });
    const periodEnd = (0, react_hook_form_1.useController)({ control: formControl, name: 'period.end' });
    const calendarFilters = (0, store_1.useRootSelector)((state) => state.calendarFilters.filter(filterHidesWarnings));
    const specificWarningFilters = calendarFilters
        .filter(isSpecificFilter)
        .flatMap((f) => f.hideWarnings);
    const allWarningsHidden = calendarFilters.some((s) => s.hideWarnings === 'all');
    const isEnabledLaborlaw = isPluginEnabled('laborlaw');
    const hideWarnings = !isEnabledLaborlaw || allWarningsHidden || transferRole === 'master';
    const visibleWarnings = new maybe_1.Maybe(dummyShift?.warnings)
        .map((_warnings) => _warnings.filter((w) => !hideWarning(specificWarningFilters, w)))
        .get(() => []);
    const isDST = (0, util_1.isValue)(timezone) &&
        isDstChangeInPeriod(periodStart.field.value, periodEnd.field.value, timezone);
    return (react_1.default.createElement(react_1.default.Fragment, null, (selectedTab === 'overview' && !hideWarnings && visibleWarnings.length) ||
        isDST ? (react_1.default.createElement("div", { style: {
            width: '100%',
            display: 'flex',
            gap: '0.5rem',
            background: 'white',
            paddingBottom: '0.5rem',
            paddingTop: '0.25rem',
        } },
        react_1.default.createElement(form_grid_layout_1.FormGridLayout, null,
            visibleWarnings.map((warning) => (react_1.default.createElement(ui_1.Tooltip, { key: warning.name, position: 'top', 
                // @ts-expect-error
                text: (0, util_1.t)(warning.messageKey ??
                    `WARNINGS_EXPLANATION.${String(warning.name)}`, warning.data), anchor: react_1.default.createElement(ui_1.Alert, { size: 'FULL_WIDTH', type: 'ERROR', 
                    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                    text: (0, util_1.t)(`WARNING_${warning.name}`) }) }))),
            isDST ? (react_1.default.createElement(ui_1.Alert, { size: 'FULL_WIDTH', type: 'WARNING', 
                // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                text: (0, util_1.t)(`WARNING_DST_CHANGE`) })) : null))) : (false)));
};
exports.ShiftWarnings = ShiftWarnings;
